import { useIsAuthenticated } from '@/hooks/useIsAuthenticated';
import { getNotificationPreferences } from '@/pages/api/scribeAPIV2';
import { reactQueryClient } from '@/utils/reactQueryClient';

import { skipToken, useQuery } from '@tanstack/react-query';
import { useQueryUser } from './useQueryUser';

export const GET_NOTIFICATION_PREFERENCES = 'GET_NOTIFICATION_PREFERENCES';

export const invalidateNotificationPreferences = () =>
  reactQueryClient.invalidateQueries({
    queryKey: [GET_NOTIFICATION_PREFERENCES],
  });

export const useQueryNotificationPreferences = () => {
  const { isAuthenticated } = useIsAuthenticated();
  const { data: user } = useQueryUser();
  return useQuery({
    enabled: !!user && isAuthenticated,
    queryKey: [GET_NOTIFICATION_PREFERENCES],
    queryFn: isAuthenticated
      ? async () => {
          const { data } = await getNotificationPreferences();
          return data;
        }
      : skipToken,
  });
};
